var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3652",
    "data-name": "Group 3652",
    transform: "translate(-428 -3614)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(428 3614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "devices-laptop-svgrepo-com",
    transform: "translate(437.911 3568.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3103",
    "data-name": "Group 3103",
    transform: "translate(16.259 65.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3102",
    "data-name": "Group 3102",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10701",
    "data-name": "Path 10701",
    d: "M298.909,196.044l-5.32.005A1.588,1.588,0,0,0,292,197.623v11.1a1.683,1.683,0,0,0,1.588,1.681h.007l5.309-.059a1.6,1.6,0,0,0,1.576-1.6l.006-11.112A1.592,1.592,0,0,0,298.909,196.044Zm-3.127.777h.94a.445.445,0,1,1,0,.891h-.94a.445.445,0,1,1,0-.891Zm-1.624.053a.464.464,0,0,1,.63,0,.454.454,0,0,1,.129.316.445.445,0,1,1-.759-.316Zm2.093,12.987a.668.668,0,1,1,.669-.668A.669.669,0,0,1,296.252,209.861Zm3.321-1.9a.223.223,0,0,1-.223.223h-6.236a.223.223,0,0,1-.223-.223V198.6a.223.223,0,0,1,.223-.223h6.236a.223.223,0,0,1,.223.223Z",
    transform: "translate(-292 -196.044)",
    fill: "#eede00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3105",
    "data-name": "Group 3105",
    transform: "translate(0 58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3104",
    "data-name": "Group 3104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10702",
    "data-name": "Path 10702",
    d: "M28.281,74.482h-1.33V59.7A1.723,1.723,0,0,0,25.125,58H3.385a1.723,1.723,0,0,0-1.826,1.7V74.482H.229c-.123,0-.229-.035-.229.088v.208a2.147,2.147,0,0,0,2.03,2.154H16.7V73.591H2.9V60H25.614V73.591H24.5v3.341h1.978a2.147,2.147,0,0,0,2.031-2.154V74.57C28.51,74.447,28.4,74.482,28.281,74.482ZM14.569,59.291a.445.445,0,0,1-.76-.316.437.437,0,0,1,.131-.314.456.456,0,0,1,.628,0,.443.443,0,0,1,.131.314A.448.448,0,0,1,14.569,59.291Z",
    transform: "translate(0 -58)",
    fill: "#eede00"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossplate);
export default __webpack_public_path__ + "static/media/crossplate.1c4da127f0529b87b7d1943bf06fa631.svg";
export { ForwardRef as ReactComponent };